// extracted by mini-css-extract-plugin
export default {"cardContainer":"SendRemainder_cardContainer__LU0S5","header":"SendRemainder_header__LfFCx","body":"SendRemainder_body__68NiA","actions":"SendRemainder_actions__5vQ2k"};